// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".organisation-pages-header[data-v-b59b0880]{box-sizing:border-box;margin-bottom:10px}@media(max-width:960px){.organisation-pages-header[data-v-b59b0880]{margin-bottom:0}}", ""]);
// Exports
module.exports = exports;
